// 登陆页
const login = {
  key_boyanIoTqiyeguanlipingtai: "SaaSユーザ管理プラットフォーム",
  key_zanwuquanxian: "暂无权限",
  key_xuanzechangjing: "选择场景",
  key_zhanghao: "账号",
  key_mima: "密码",
  key_denglu: "登录",
  key_jizhuzhanghaomima: "记住密码",
  key_wangjimima: "忘记密码？",
  key_quzhuce: "去注册",
  key_xitongyichang: "系统异常",
  key_bushikehu: "不是客户？",
  key_mianfeishiyong: "免费试用",
  key_qingshuruyonghuming: "请输入用户名",

  //注册页
  key_zhuce: "注册",
  key_zhucechenggong: "注册成功",
  key_gongsimingcheng: "公司名称",
  key_suozaiquyu: "所在区域",
  key_changjingleixing: "场景类型",
  key_lianxirenmingcheng: "联系人名称",
  key_lianxidianhua: "联系电话",
  key_youxiang: "邮箱",
  key_youxiangyanzhengma: "邮箱验证码",
  key_zhanghumima: "账户密码",
  key_querenmima: "确认密码",
  key_yanzhengmafasongdaoyouxiang: "您的验证码已发送至您的邮箱",
  key_qingquerenmima: "请确认密码",
  key_fasongyanzhengma: "发送验证码",
  key_qingshuruzhengqueyouxianggeshi: "请输入正确的邮箱格式",
  key_qingshuruzhengquemimageshi: "请输入正确的密码格式",
  key_mimabuyizhi: "两次密码不一致",
  //注册成功
  key_nindexinxiyitijiao: "您的信息已提交",
  key_yigegongzuorineiwancheng: "1个工作日内将完成审核",
  key_ruyouwentiqinglianxi: "如有问题，请联系 400-000-6282",
  key_tijiaochenggong: "提交成功!",

  //找回密码
  key_zhaohuimima: "找回密码",
  key_forgetwarning1: "请填写您需要找回的账号，按提示步骤找回密码",
  key_xinmima: "新密码",
  key_mimachongzhichenggong: "恭喜，租户管理后台的账号重置密码成功！",
  key_zhijiedenglu: "直接登录",
  key_mimaxiugaichenggong: "密码修改成功"
};

// 头部导航栏
const headerLang = {
  key_xiangmugaikuang: "项目概况",
  key_shebeiguanli: "设备管理",
  key_nenghaoguanli: "能耗管理",
  key_baojingguanli: "报警管理",
  key_weibaoguanli: "维保管理",
  key_yonghuguanli: "用户管理",
  key_yunweitongzhi: "运维通知",
  key_kongzhitai: "コンソール",
  key_gerenxinxi: "個人情報",
  key_xiugaimima: "パスワードを変更する",
  key_gengxingongsixinxi: "会社情報を更新する",
  key_gexingpeizhi: "プロファイル設定",
  key_jueseguanli: "役割管理",
  key_tuichu: "ログアウト",
  // 默认值
  key_zuhuguanlihoutai: "IoT SAASユーザー管理プラットフォーム",
  key_zanwuyingyong: "アプリケーションがありません",
  key_xingqiyi: "月曜日",
  key_xingqier: "火曜日",
  key_xingqisan: "水曜日",
  key_xingqisi: "木曜日",
  key_xingqiwu: "金曜日",
  key_xingqiliu: "土曜日",
  key_xingqiri: "日曜日",
  //空气质量
  key_huanjingshuju: "環境データ",
  key_shuxing: "属性",
  key_kongqizhiliang: "空気の質",
  key_sheweimoren: "デフォルトにする",
  key_wendu: "温度",
  key_shidu: "湿度"
};

// 左侧导航栏
const Aside = {
  // 设备
  key_shebeizonglan: "设备总览",
  // 能耗
  key_zongnenghaotongji: "总能耗统计",
  key_yongshuitongji: "用水统计",
  key_yongdiantongji: "用电统计",
  // 报警
  key_shishibaojing: "实时报警",
  key_baojingfenxi: "报警分析",
  key_baojingdingyi: "报警定义",
  // 维保
  key_weibaofenxi: "维保分析",
  key_dangqianrenwu: "当前任务",
  key_weibaolishi: "维保历史",
  key_dianjianxunjian: "点检巡检",
  key_weiwaijigai: "委外技改",
  key_weiwaigongdan: "委外工单",
  key_baojingrenwufenpei: "报警任务分配",
  // 用户
  key_shouye: "员工管理",
  key_shouye: "员工列表",
  // 运维
  key_shouye: "发布历史",
  key_shouye: "发布通知",
  // 空间
  key_shouye: "组织架构配置",
  key_shouye: "空间配置",
  key_shouye: "岗位类型配置",
  key_shouye: "水电费配置",

  key_shouye: "首页",
  key_yuangongguanli: "员工管理",
  // 'key_yuangongshouquanjilu': '员工授权记录',
  // 'key_fangkeguanli': '访客管理',
  // 'key_fangkexingcheng': '访客行程',
  // 'key_fangkerenzhengjilu': '访客认证记录',
  // 'key_huiyishiguanli': '会议室管理',
  // 'key_gongweiguanli': '工位管理',
  key_shebeiguanli: "设备管理",
  key_xitongshezhi: "系统设置",
  key_qiyeziliao: "企业资料",
  key_shezhi: "设置",
  key_xiugaimima: "修改密码",
  key_gerenxinxi: "个人信息",
  key_tuichu: "ログアウト"
};

//公用
const common = {
  //概念
  key_baojing: "アラーム",
  key_shebei: "設備",

  //按钮类
  key_zanwushuhju: "データなし",
  key_shangyibu: "前へ",
  key_xiayibu: "次へ",
  key_queren: "確認",
  key_quxiao: "キャンセル",
  key_guanbi: "閉じる",
  key_wancheng: "完了",
  key_tijiao: "送信",
  key_yulan: "プレビュー",
  key_quanbu: "全部",
  key_zidingyi: "カスタム",
  key_chakan: "表示",
  key_xuhao: "番号付け",

  key_daochubiaogemingxi: "表の詳細をエクスポートする",

  //区域类
  key_weizhi: "位置",
  key_quyu: "エリア",
  key_xuanzequyu: "領域を選択",

  //比例类+数量类
  key_bili: "スケール",
  key_leixing: "タイプ",

  key_zaixianshu: "オンライン",
  key_zaixianlv: "オンラインレート",
  key_qiyonglv: "有効率",
  key_guzhanglv: "故障率",
  key_chulilv: "処理率",
  key_chenggonglv: "成功率",
  key_pingjunzhi: "平均値",

  //时间段
  key_shijian: "時間",
  key_kaishiriqi: "開始日",
  key_jieshuriqi: "終了日",
  key_riqixuanze: "日付の選択",
  key_Jan: "1月",
  key_Feb: "2月",
  key_Mar: "3月",
  key_Apr: "4月",
  key_May: "5月",
  key_Jun: "6月",
  key_Jul: "7月",
  key_Aug: "8月",
  key_Sep: "9月",
  key_Oct: "10",
  key_Nov: "11",
  key_Dec: "12",
  key_xuanzeyihuoduogeyuefen: "1ヶ月以上を選択する",

  key_zuotian: "昨日",
  key_jinqitian: "最近の7日間",
  key_jinsanshitian: "最近の30日間",
  key_jinsangeyue: "この3ヶ月",
  key_jinbannian: "この半年",
  key_benzhouqi: "本サイクル",
  key_bishangzhouqi: "前のサイクルと比較して",
  key_shangzhouqi: "前のサイクル",
  key_zhouqi: "サイクル",
  key_shijianduan: "時間帯",
  key_quanshijianduan: "全期間帯",
  key_tongbishangzhou: "先週と比較して",

  //单位类
  key_danwei: "単位",
  key_shuliang: "数量",
  key_tai: "台",
  key_tiao: "件",
  key_ge: "個",
  key_fen: "点",
  key_tian: "日",
  key_yue: "月",
  key_xiaoshi: "時間",
  key_fenzhong: "分",
  key_miaozhong: "秒",

  key_yuan: "元",
  key_wanyuan: "万元",

  //状态
  key_zhuangtai: "状態",
  key_zhengchang: "正常",
  key_yichang: "異常",
  key_yiqiyong: "有効にしました",
  key_weiqiyong: "有効化されていません",
  key_weichuli: "未処理",
  key_chulizhong: "処理中",
  key_yichuli: "処理済み",
  key_zaixian: "オンライン",
  key_lixian: "オフライン",
  key_lianghao: "良好である",
  key_yanzhong: "深刻である",
  key_zhongdeng: "中ぐらい",
  key_yiban: "一般",
  key_jiaocha: "较差",
  key_zanwushuju: "データがありません",
  key_weizhixing: "実行されていません",
  key_yiwancheng: "完了しました",
  key_zhixingzhong: "実行中",

  //placeholder 类
  key_qingshuru: "入力してください",
  key_qingxuanze: "選択してください",

  //提示类
  key_cicaozuojiangshanchugairenwu: "此操作将删除该任务, 是否继续?",
  key_yiquxiaoshanchu: "削除を取り消しました",
  key_tianjiarenwuchenggong: "タスクの追加に成功しました",
  key_tianjiarenwushibai: "タスクの追加に失敗しました",
  key_bianjirenwuchenggong: "タスクの編集に成功しました",
  key_bianjirenwushibai: "タスクの編集に失敗しました",
  key_shanchuchenggong: "削除に成功しました",
  key_xiugaichenggong: "修正に成功しました",
  key_tianjiachenggong: "追加に成功しました",
  key_tianjiayingyonghouzaicaozuo:
    "アプリケーションを追加してから操作してください",
  key_quedingshanchugangweileixing: "該当部署のタイプを削除しますか？",
  key_changjingtishi1: "有効期限がきました",
  key_changjingtishi2: "有効期限が過ぎたので、無効になりました。",
  key_changjingtishi3: "無効になりました",
  key_changjingtishi4: "必要があれば、直ちに連絡してください。400 000 6282",
  key_qingwanshanbiaogexinxi: "フォーム情報を完成させてください。",
  key_xinjianjuesechenggong: "新しい役割の作成に成功しました",
  key_xinjianjuesechenggong: "编辑角色成功"
};

// 项目概览
const projectOverviewLang = {
  key_danxiangmujiashicang: "単項目の操作室",
  key_quanxiangmujiashicang: "全項目の操作室",
  key_qiyongbili: "有効率統計スケール図",
  key_zaixianbili: "オンラインレート統計スケール図",
  key_shebeibilifenxitu: "設備スケール分析図",
  key_shebeixiaoxizongliang: "設備情報総量",
  key_shebeizongshu: "デバイス総数",
  key_xiaoxizongshu: "メッセージ総数",
  key_gongdanxiangyingshijian: "作業命令に対する応答時間",
  key_pingjunshijian: "平均時間",
  key_zuichangshijian: "最長時間",
  key_zuiduanshijian: "最短時間",
  key_shebeibaojing: "設備アラーム",
  key_shebeilixian: "設備オフライン",
  key_shebeizaixian: "設備オンライン",
  key_gongdandaizhixing: "作業命令実行待ち",
  key_baojingshujuchuli: "アラームデータ処理",
  key_daichuli: "処理待ち",
  key_yichuli: "処理済み",
  key_jinyigeyuejingbaoshuju: "最近1か月のアラームデータ",
  key_jinyigeyuenenghaoshuju: "最近１ヶ月のエネルギー消費データ",
  key_quanpingmoshi: "フルスクリーンモード",
  key_shebeijiankang: "設備の状態",
  key_zongtiyunxing: "全体の運転状態",
  //全项目驾驶舱页面
  key_jiashicang: "操作室",
  key_quanbushebeishuliang: "全設備数",
  key_quanbuxiaoxishuliang: "すべてのメッセージの数",
  key_nenghaoqushitu: "エネルギー消費動向図",
  key_baojingqushitu: "アラームトレンド図",
  key_yingyongfenbu: "アプリケーションの分布",
  key_jieruyingyongzongshu: "アクセスしたアプリケーションの総数",
  key_baojingbilitu: "アラームスケール図",
  key_yingyongdizhi: "アプリケーションアドレス",
  key_yingyongchuanjianshijian: "アプリケーションの作成時間",
  key_shebeishuliang: "設備の数",
  key_xiaoxishuliang: "メッセージの数",
  key_xiangmuyunweizongrenshu: "プロジェクトの運営・維持総人数",
  key_gongdandaichulishuliang: "作業命令処理数量",
  key_shebeibaojingshuliang: "設備のアラーム数",
  key_shebeilixianshuliang: "設備のオフライン数",
  key_qingshuruguanjianzi: "キーワードを入力して検索してください",
  key_zonggongjiedian: "総節電",
  Key_jieyueyongdian: "電気を節約する",
  key_yunweirenjunengxiaotisheng:
    "オペレータ一人当たりのエネルギー効率を向上させる",
  key_zhongyangkongtiaozongjienenglv:
    "オペレータ一人当たりのエネルギー効率を向上させる",
  key_bingxulengzongjienenglv:
    "アイスストレージのトータル省エネ率をすべて適用する",
  key_quanbuyingyongpingjungongdan: "平均の作業命令応答時間をすべて適用する"
};

//设备管理
//1.设备总览
const deviceoverviewLang = {
  key_shebeizonglan: "設備概要",
  key_shebeizongshuUnit: "設備総数（台/個）",
  key_jinrituisongxiaoxishu: "本日のプッシュメッセージ数（回）",
  key_jinrixiafaminglingshu: "本日の発行命令数(回)",
  key_jinrixinzengshebeishu: "本日の追加設備数",
  //引用公用类
  key_wancheng: "完成",
  key_gexitongshebeiguzhangqushitu: "各システム設備の故障傾向図",
  key_qingxuanzeshebeileixing: "デバイスのタイプを選択してください",
  key_shebeizongtiqingkuangfenxi: "設備全体の状況分析",

  //系统分类菜单
  key_quanbuzailixianzhuangtai: "全てオンライン/オフライン状態",
  key_quanbubaojingzhuangtai: "全てアラーム状態",
  key_baojingzhong: "アラーム中",
  key_zaixianzhuangtai: "オンライン状態",
  key_jingbaozhuangtai: "アラーム状態",
  key_zutaiyemian: "グループページ",
  key_caozuozhuangtai: "操作状態",
  key_diaoru: "呼び出し",
  key_yaunchengkongzhi: "リモートコントロール",
  key_kaiguan: "オン/オフ",
  key_dingshikai: "定時に開く",
  key_dingshiguan: "定時に止める",

  //设备详情
  key_shebeixiangqing: "機器の詳細",
  key_jichuxinxi: "基本情報",
  key_suoshuleixing: "所属タイプ",
  key_ruwangshijian: "ネットタイム",
  key_shebeiID: "デバイスID",
  key_shebeizhandian: "デバイス局",
  key_xuliehao: "シリアル番号",
  key_shebeierweima: "デバイス二次元コード",
  key_shebeidangan: "デバイスファイル",
  key_zhixingjieguo: "実行結果",
  key_zerenren: "責任者"
};

//能耗管理
const energyConsumLang = {
  //1.总能耗统计
  key_nenghaofenbu: "エネルギー消費分布",
  key_zongnenghaotongji: "総エネルギー消費統計",
  key_yiji: "レベル1",
  key_suoxuan: "選択",
  key_quyunenghaoxiaofeiqingkuang: "地域エネルギー消費状況",
  key_shuifeizonglan: "水道料金総覧",
  key_dianfeizonglan: "電気料金総覧",

  //2.用水统计
  key_yongshuitongji: "用水統計",
  key_tongjifangshi: "統計方式",
  key_anfeiyong: "費用に応じて",
  key_anyongliang: "使用量に応じて",

  //2.用电统计
  key_yongdiantongji: "電力統計",
  key_quedingyaoshanchu: "确定要删除",
  key_dangqianjigouxiayouzijigou:
    "現在の機構の下にサブ機構が設置されていますが、実行後は全て削除され、元に戻せません。削除しますか？"
};

//报警管理
const alarmManagementLang = {
  //1.实时报警

  key_baojingliebiao: "アラームリスト",
  key_shebeibaojing: "設備アラーム",
  key_shebeiyujing: "設備警告",
  key_yuxingyujing: "運行警報",
  key_chulizhuangtai: "処理状態",
  key_baojingjibie: "アラームレベル",
  key_chanpinleixing: "製品の種類",

  key_baojingshijian: "アラーム時間",
  key_baojingneirong: "アラームの内容",
  key_shebeimingcheng: "デバイス名",
  key_shebeiweizhi: "デバイスの位置",
  key_chiixushijian: "持続時間",

  //2.报警分析

  key_baojingfenxi: "アラーム分析",
  key_baojingleixingfenxi: "アラームタイプ分析",
  key_baojingpinjunchixushijian: "アラーム平均継続時間",

  key_baojinghuodongfenbu: "アラーム活動分布",
  key_leijishebeibaojingshu: "積算設備アラーム数",
  key_leijishebeiyujingshu: "積算設備警告数",
  key_leijiyunxingyujingshu: "積算運転警告数",
  key_baojingshu: "アラーム数",

  //3.报警定义
  key_baojingdingyi: "アラームの定義"
};

//维保管理
const maintenanceManagementLang = {
  //1.报警分析
  key_weibaofenxi: "メンテナンス分析",
  key_gongdantongji: "作業指示統計",
  key_quanbuweibaoleixing: "全てのメンテナンスタイプ",

  key_weiwaiweixiu: "外注修理",
  key_weiwaijigai: "外注技術改革",
  key_dianxunjian: "ポイントパトロール",
  key_yuangongshangbao: "作業員レポート",

  key_gongdanzongshu: "作業指示総数",
  key_yichuligongdanshu: "処理済み件数",
  key_pingjungongdanchulishijian: "作業指示平均処理時間",

  key_gongdantongjiqushitu: "作業指示統計トレンド図",
  key_gongdanchulijieguotongji: "作業指示処理結果統計",
  key_yuangongchuligongdan: "作業員の作業指示処理に対する積極性ランキング",
  key_paiming: "ランキング",
  key_gongdanchulilv: "作業指示処理率",

  //2.当前任务
  key_dangqianrenwu: "現在の役割",
  key_anweibaorenyuansousuo: "メンテナンス対象/設備位置/割り当て者による検索",

  key_weibaoduixiang: "维保对象",
  key_weibaoleixing: "メンテナンスのタイプ",
  key_weibaoneirong: "メンテナンスの内容",
  key_fenpeizhi: "割り当て",
  key_renwubeizhu: "タスクのコメント",
  key_faqishijian: "開始時間",
  key_wanchengshijian: "終了時間",

  //工单详情
  key_gongdanxiangqing: "作業指示の詳細",
  key_tijiaoren: "提出者",
  key_tijiaorenlianxifangshi: "提出者の連絡方法",

  //3.维保历史
  key_weibaolishi: "メンテナンス履歴",
  key_quanbuchulijieguo: "全ての処理結果",
  key_tiaoshichenggong: "調整済",
  key_wubao: "誤報",
  key_chulijieguo: "処理結果",

  //4.点检巡检
  key_anjihuamingchengsousuo: "計画名で検索する",
  key_jihuamingcheng: "計画名",
  key_xinzengdianxunjianjihua: "ポイント巡回計画を追加",
  key_bianjidianxunjianjihua: "ポイント巡回計画を編集",
  key_zhixingzhuangtai: "実行状態",
  key_zhixing: "実行",
  key_quxiaozhixing: "実行をキャンセル",

  key_xuanzedianjianfanwei: "点検範囲を選択する",
  key_xuanzedianjianleimu: "点検項目を選択する",
  key_xuanzeweihuxiang: "保守項目を選択する",
  key_zhixingshijian: "実行時間",
  key_yuxuanze: "ドメインの選択",

  key_dianjianren: "点検者",

  key_weihuxiang: "メンテナンス項目",
  key_jizhun: "基準",
  key_xunjianquyu: "パトロールエリア",

  //5.委外技改
  key_weiwaigongdan: "外注作業指示",
  key_quanburenwuleixing: "全てのタスクタイプ",
  key_quanbugongdanzhuangtai: "全ての作業指示状態",
  key_daigenjin: "実行待ち",
  key_genjinzhong: "実行中",
  key_yiwancheng: "完了済",
  key_renwuleixing: "タスクの種類",
  key_gongdanzhuangtai: "作業指示状態",
  key_baojingxinxi: "アラーム情報",
  key_gongdanbeizhu: "作業指示についての備考",
  key_dianjian: "点検",
  key_xunjian: "パトロール",
  key_kancha: "実地調査",
  "key_anweibaoduixiang/shebeiweizhisousuo":
    "メンテナンス対象/設備位置/割り当て者による検索",

  //6.报警任务分配
  key_baojingrenwufenpei: "アラームタスク割り当て",
  key_anshebeimingchengsousuo: "デバイス名/割り当て者による検索",
  key_zuihoubianjishijian: "最後の編集時間"
};

//运维通知
const noticeManagementLang = {
  //1.发布历史
  key_fabulishi: "リリース履歴",
  key_fabu: "リリース",
  key_fabuxintongzhi: "新しい通知をリリースする",
  key_tongzhizhuti: "お知らせのテーマ",
  key_tongzhineirong: "お知らせの内容",
  key_luokuanneirong: "落款の内容",
  key_fabushijian: "リリース時間",
  key_noticeWarning: "通知が発行されたら、すべてのユーザAPPに送信されます。",
  key_xinjiantongzhichenggong: "新規通知に成功しました"
};

//系统配置
const systemSettinManagementLang = {
  //1.组织架构配置
  key_zuzhijiagoupeizhi: "組織構造を構成する",
  key_daoruzuzhijiagou: "組織構造をインポートする",
  key_xinjianzijigou: "新規サブ機構",
  key_xinjiantongjijigou: "新規同級機関",

  key_kongjianpeizhi: "スペース設定",

  //3.岗位类型配置
  key_gangweileixingpeizhi: "所属タイプの設定",
  key_xinjiangangweileixing: "新規部署タイプ",
  key_bianjigangweileixing: "部署のタイプを編集する",
  key_gangweileixingmingcheng: "部署タイプ名",
  key_peizhishijian: "設定時間",

  //4.水电费配置
  key_shuidianfeipeizhi: "水および電気料金の設定",
  key_dianfeipeizhi: "電気料金の設定",
  key_shuifeipeizhi: "水道料金の設定",
  key_gengxinpeizhitiaojian: "更新配置条件",
  key_tiaozhengdanjia: "调整单价",
  key_danjia: "单价",
  key_shiduan: "时段",
  key_digu: "低谷",
  key_pingduan: "平段",
  key_gaofeng: "高峰",
  key_jianfeng: "尖峰",
  key_jianfengyuefenshezhi: "尖峰月份设置",
  key_dianyajijiaqujian: "电压计价区间",
  key_quanshiduan: "全时段",
  key_peizhichenggong: "配置成功",
  key_suoyouxianweibitian: "所有项为必填项",
  key_xuanzeyigehuoduogeyue: "选择一个或多个月份",
  key_qingxiangengxinpeizhitiaojian: "请先更新配置条件"
};

//个人中心
const personalSettingLang = {
  //更改公司信息
  key_genggaigongsixinxi: "更改公司信息",
  key_gexingshezhitishi1: "若公司信息有更新，请发送邮件到",
  key_gexingshezhitishi2: "博彦物联网运维人员收到邮件后，会及时与您联系并核实",

  //个性配置
  key_pingtailogo: "平台logo",
  key_xuanzepingtaizhusediao: "选择平台主色调",
  key_shebeijierupingtaimingcheng: "设备接入平台名称",
  key_dapingxianshimingcheng: "大屏显示名称",
  key_gexingshezhitishi3:
    "图片像素为38像素*38像素，大小不超过3M，.png格式的logo"
};

// 员工管理
const staffManagement = {
  //角色

  key_APPgongnengquanxianliebiao: "APP功能权限列表",
  key_dibudaohang: "底部导航",
  key_duiyingzicaidan: "对应子菜单",
  key_peizhigongneng: "+ 配置功能",
  key_xuanzepeizhimokuai: "选择配置模块",
  key_dibuxuanzemokuaitishi1: "底部导航最少选择2个模块",
  key_dibuxuanzemokuaitishi2: "底部导航最多选择5个模块",

  key_houtaiyonghu: "后台用户",
  key_yonghudenglumima: "用户登录密码",
  key_qingshuruyonghudenglumima: "请输入用户登录密码",
  key_xinjianzhanghu: "新建账户",
  key_bianjizhanghu: "编辑账户",
  key_zhanghuxinxi: "账户信息",
  key_youxiang: "邮箱",
  key_juese: "角色",
  key_chuangjianchenggong: "创建成功",
  key_qingxuanzejuese: "请选择角色",
  key_shifouyaoshanchugaizhanghu: "确认要删除该账户吗？",
  zhanghu: "账户",
  key_querenjinyongma: "确定要禁用此账户吗？",
  key_querenqiyongma: "确定要启用此账户吗？",
  key_jinyongchenggong: "禁用成功！",
  key_qiyongchenggong: "启用成功！",
  key_yuangongliebiao: "员工列表", //
  key_jiansuotiaojian: "检索条件",
  key_yuangonggonghao: "员工工号", //
  key_xingming: "姓名", //
  key_gangweileixing: "岗位类型", //
  key_gongzuoquyu: "工作区域", //
  key_renliancaijizhuangtai: "人脸采集状态",
  key_chuangjianshijian: "创建时间", //
  key_quanbu: "全部",
  key_yicaiji: "已采集",
  key_weicaiji: "未采集",
  key_qingkong: "清空",
  key_yuangongxingming: "员工姓名",
  key_menjinrenzhengzhuangtai: "门禁认证状态",
  key_yirenzheng: "已认证",
  key_weirenzheng: "未认证",
  key_renzhengzhong: "Verifying",
  key_renzhengshibai: "Verifying failed",
  key_sousuo: "搜索",
  key_xinjian: "新建",
  key_bianji: "编辑", //
  key_shanchu: "删除", //
  key_daochushuju: "导出数据",
  key_zhongwenxingming: "中文姓名", //
  key_xingbie: "性别", //
  key_zaizhizhuangtai: "在职状态",
  key_shoujihaoma: "手机号码", //
  key_suoshubumen: "所属部门", //
  key_bangongdidian: "办公地点",
  key_caozuo: "操作", //

  key_gong: "共",
  key_ye: "页",
  key_tiaoshuju: "条数据",
  key_meiyexianshi: "每页显示",
  key_xianshiquanbushuju: "显示全部数据",
  key_zaizhi: "在职",
  key_lizhi: "离职",
  key_qingxuanzeyuangonghouzaijinxingshanchu: "请至少选择一项后再进行删除！", //
  key_shifouyaoshanchusuoxuanyuangong: "是否要删除所选员工?", //

  key_tishi: "提示",
  key_queding: "确定",
  key_quxiao: "取消",
  // 'key_shanchuchenggong': '删除成功',
  key_shanchuyuangong: "删除员工", //
  key_daochuyuangong: "导出员工", //
  key_xingmingshoujihaoyouxiang: "按姓名/手机号/邮箱搜索" //
};

// 新建/编辑员工
const newStaff = {
  key_xinjianyuangong: "新建员工", //
  key_bianjiyuangong: "编辑员工", //
  key_piliangshanchu: "批量删除",
  key_jibenxinxi: "基本信息", //
  key_suoshuzuzhi: "所属组织",
  key_yingwenxingming: "英文姓名",
  key_xingbie: "性别",
  key_nan: "男", //
  key_nv: "女", //
  key_gangwei: "岗位",
  key_yuangongleixing: "员工类型",
  key_ruzhiriqi: "入职日期",
  key_gerenyouxiang: "个人邮箱", //
  key_APPmima: "APP密码", //
  "key_8~16weishuzi,zimuhunhe": "8~16位数字，大小写字母,特殊字符组合", //
  key_zaicishurumima: "再次输入密码", //
  key_renzhengxinxi: "认证信息",
  key_renlianxinxi: "人脸信息",
  key_menjinrenzheng: "门禁认证",
  key_baocun: "保存", //
  key_quxiao: "取消",
  key_fanhui: "返回", //
  key_jianzhiyuangong: "兼职员工",
  key_quanzhizhengshiyuangong: "全职正式员工", //
  key_lizhi: "离职", //
  key_zaizhi: "在职", //
  key_xuanzeriqi: "选择日期",
  key_yuangongxinxi: "员工信息", //
  key_qingshuruyuangongweiyihao: "请输入员工唯一号", //

  key_qingshurushoujihaoma: "请输入手机号码", //
  key_qingshurugerenyouxiang: "请输入邮箱", //
  key_qingshuruAPPmima: "请输入APP密码", //
  key_qingzaicishurumima: "请再次输入密码", //
  // 'key_qingxuanzegongzuoquyu':'请选择工作区域',
  key_qingshuruyuangonggonghao: "请输入员工工号（纯数字）", //
  key_qingshuruxingming: "请输入姓名", //
  key_bumen: "部门", //
  key_shoujihaobunengweikong: "手机号不能为空", //
  key_qingshuruzhengquedeshoujihao: "请输入正确的手机号", //
  key_qingshuruchunshuzi: "请输入纯数字的员工工号", //
  key_yungonggonghaobunengweikong: "员工工号不能为空", //
  //   'key_zanwushuju':'暂无数据',

  key_qingxuanzezaizhizhuangtai: "请选择在职状态", //
  key_qingxuanzegangweileixing: "请选择岗位类型", //
  key_qingxuanzeyuangong: "请选择员工",
  key_qingxuanzesuosubumen: "请选择所属部门", //
  key_qingxuanzegongzuoquyu: "请选择工作区域", //
  key_qingshurushoujihao: "请输入手机号", //
  key_qingshuruzhengquedeyouxiang: "请输入正确的邮箱", //
  key_qingshuruzhongwenxingming: "请输入中文姓名", //
  key_qingshurumima: "请输入密码", //
  key_qingchongfushurumima: "请重复输入密码", //
  key_liangcishurudemimabuyizhi: "两次输入的密码不一致", //
  key_tianjiachenggong: "创建成功",
  key_bianjichenggong: "编辑成功", //
  key_fenpeichenggong: "分配成功",
  key_riqibunengweikong: "日期不能为空"
};

// 员工授权记录
const empowerPeople = {
  // 'key_shebeimingcheng': 'デバイス名',
  key_qingkong: "清空",
  key_shouquanzhuangtai: "授权状态",
  key_shebeibianhao: "设备编号",
  key_quyubianhao: "区域编号",
  key_bangongshibianhao: "办公室编号",
  // 'key_chuangjianshijian': '创建时间',
  key_yishouquan: "已授权",
  key_jujue: "拒绝",
  key_weishouquan: "未授权"
};

// 通用设置
const generalSettings = {
  key_tongyongshezhi: "通用设置",
  key_xianshishijianshezhi: "显示时间设置",
  key_huanyingpingtiqianxianshishijian: "欢迎屏提前显示时间（分钟）",
  key_huanyingpingyanhouxianshishijian: "欢迎屏延后显示时间（分钟）",
  key_huanyingpingyanhoujieshuxianshishijian: "欢迎屏延后结束显示时间",
  key_huiyishitiqianxianshishijian: "会议室提前显示时间（分钟）",
  key_huiyishiyanhouxianshishijian: "会议室延后显示时间（分钟）",
  key_gongweitiqianxianshishijian: "工位提前显示时间（分钟）",
  key_jienengshijianshezhi: "节能时间设置",
  key_huiyishitiqianganyingshijian: "会议室提前感应时间（分钟）",
  key_gongweiqishenganyingshijian: "工位起身感应时间（分钟）",
  key_huanyingpingbeijingshezhi: "欢迎屏背景设置",
  key_tupianchicunwei19201200JPGPNGgeshi: "图片尺寸为1920*1200,JPG/PNG格式",
  key_shangchuantupian: "上传图片",
  key_tijiao: "提交",
  key_tupianshangchuanchenggong: "图片上传成功",
  key_baocunchenggong: "保存成功",
  key_baocunshibai: "保存失败",
  key_shangchuangeshijinweiAPKdaxiao100MB: "上传格式仅为APK, 大小100MB",
  key_dangqianxianzhixuanze3gewenjianbencixuanzele:
    "当前限制选择 3 个文件，本次选择了",
  key_gewenjiangongxuanzele: "个文件，共选择了",
  key_gewenjian: "个文件",
  key_yonghuanzhuangbao: "用户安装包",
  key_fangkerenzhengshenqinganzhuangbao: "访客认证安装包",
  key_quedingyichu: "确认移除",
  key_jiangwenjiantuodaocichuhuo: "将文件拖到此处,或 ",
  key_dianjishangchuan: "点击上传",
  key_anzhuangbaoshezhi: "安装包设置",
  key_shangchuanshijian: "上传时间",
  key_dangqianbanben: "当前版本",
  key_dianjitupianshangchuan: "点击图片上传",
  key_shangchuanchenggong: "上传成功",
  key_shangchuanshibaibanbenguicecuowu: "上传失败,版本规则错误"
};
// 其他
const rests = {
  key_jinggao: "warning",
  key_qingxuanzeshijianduan: "Please select time period",
  key_shi: "是",
  key_fou: "否",
  key_lianjiechaoshi: "连接超时",
  key_yuyan: "语言",
  key_zhongwen: "中文",
  key_yingwen: "英文"
};

// 角色
const roleList = {
  key_juese: "角色",
  key_zhuangtai: "状态",
  key_qingshurujuesemingcheng: "请输入角色名称（15字以内）",
  key_qingshurujuesemingcheng1: "请输入角色名称",
  key_qingshurujuesemiaoshu: "请输入角色描述（30字以内）",
  key_anjuesemingchengsousuo: "按角色名称搜索",
  key_juesemingcheng: "角色名称",
  key_juesemiaoshu: "角色描述",
  key_xinjianjuese: "新建角色",
  key_qiyong: "启用",
  key_jinyong: "禁用",
  key_bianji: "编辑", //
  key_peizhiquanxian: "配置权限",
  key_querenjinyongjuesema: "确定要禁用该角色吗？",
  key_querenqiyongjuesema: "确定要启用该角色吗？",
  key_shifouyaoshanchugaijuese: "确定要删除该角色吗？",
  key_juesexinxi: "角色信息",
  key_shuoming: "说明：左侧选择企业应用（可多选),右侧为其对应的功能权限配置。",
  key_xuanzeyingyong: "选择应用",
  key_duiyinggongnengquanxian: "对应功能权限",
  key_peizhiquanxianchenggong: "配置权限成功",
  key_qingxuanzeyingyong: "请选择应用",
  key_qingxuanzequanxian: "请选择权限",
  key_zanwuyingyongqingxianjian: "暂无应用，请先新建应用！"
};

export default {
  login, //登录
  headerLang, //头部导航栏
  Aside, //左侧导航栏
  common, //公用
  projectOverviewLang, //项目概览
  deviceoverviewLang, //设备管理
  energyConsumLang, //能耗管理
  alarmManagementLang, //报警管理
  maintenanceManagementLang, //维保管理
  noticeManagementLang, //运维通知
  systemSettinManagementLang, //系统配置
  personalSettingLang, //个人中心

  staffManagement, //员工管理
  newStaff,
  empowerPeople,

  generalSettings,

  rests,

  // maintenanceManagement,
  roleList
};



// WEBPACK FOOTER //
// ./src/assets/lang/ja.js